import axios from 'axios'
import React, { useContext, useEffect, useState, useRef } from 'react'
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import moment from 'moment';

import authContext from '../context/authContext/authContext';
import AddPartner from '../components/modals/AddPartner';
import EditPartner from '../components/modals/EditPartner';
import { useDispatch, useSelector } from 'react-redux';
import { deletePartnerAction, getPartnersAction } from '../redux/actions/partnersAction';
import { showStatus, toTitleCase } from '../utils/utils';
import UserDetailsModal from '../components/modals/UserDetailsModal';
import AddAchievement from '../components/modals/AddAchievement';
import { deleteAchievementAction, getAchievementsAction } from '../redux/actions/achievementsAction';
import EditAchievement from '../components/modals/EditAchievement';


const Achievements = () => {
  const dispatch = useDispatch();
  const { getConfig } = useContext(authContext)
  const config = getConfig();
  const fetchedRef = useRef(false);
  const intialState = { reqUserId: '', showUserDetailsModal: false }
  const [state, setCompleteState] = useState(intialState)
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }))

  const { loading, achievements } = useSelector((state) => state.achievements)

  // const { loading, users } = useSelector((state) => state.users)

  const deletePartner = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      showCancelButton: true,
      reverseButtons: true // 👈 this does the trick
    }).then((result) => {
      if (result.isConfirmed) {
        confirmDeleteAchievement(id);
      }
    });
  }

  const confirmDeleteAchievement = async (id) => {
    const data = { id }
    dispatch(deleteAchievementAction(data, config, getAchivements))
  }

  const getAchivements = async () => {
    dispatch(getAchievementsAction(config))
  }

  useEffect(() => {
    if (fetchedRef.current) {
      return;
    }

    fetchedRef.current = true;
    getAchivements();
  }, []);

  const onUserIdClick = (userId) => {
    setState({ reqUserId: userId, showUserDetailsModal: true })
  }

  return (
    <div className='main-container pb-1'>
      <div className="card-box mb-30">
        <div className='table-card-header'>
          <div className='d-flex align-items-center'>
            <h2 className="h4 mb-0 py-2">Partners Achievements</h2>
            {loading ? (
              <div className='ml-3'>
                <div className="spinner-border spinner-border-sm text-primary" role="status" />
              </div>
            ) : null}
          </div>
          <div>
            <button className='btn gleamdesk-blue' onClick={() => setState({ openAddAchievementrModal: true })} disabled={loading}>
              <i className='fa fa-plus mr-1' />
              <span>Add Achievement</span>
            </button>
          </div>
        </div>
        <div className="overflow-x-scroll">
          <table className="table table-hover">
            <thead>
              <tr>
                <th scope="col">Partner</th>
                <th scope="col">Event</th>
                <th scope="col">Achievement</th>
                <th scope="col">Created At</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {(achievements || []).map((achievement) => {
                const { _id, userId, event, achievement: medal, createdAt } = achievement;
                return (
                  <tr key={_id}>
                    <td className='cursor-pointer btn-user-info' onClick={() => onUserIdClick(userId)}>{userId}</td>
                    <td>{event || '-'}</td>
                    <td>{medal || '-'}</td>
                    <td>
                      <div>{moment(createdAt).format("DD/MM/YYYY")}</div>
                      <div className='text-muted fs-12'>{moment(createdAt).format("h:mm a")}</div>
                    </td>
                    <td className='actions-container'>
                      <button className='btn btn-secondary btn-sm my-1 mx-1' onClick={() => setState({ openEditAchievementModal: true, achievementId: _id })} disabled={loading}>
                        <i className='fa fa-pencil' />
                      </button>
                      <button className='btn btn-danger btn-sm my-1 mx-1' onClick={() => deletePartner(_id)} disabled={loading}>
                        <i className='fa fa-trash' />
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>

      <AddAchievement
        isOpen={state?.openAddAchievementrModal}
        toggle={() => setState({ openAddAchievementrModal: false })}
        getAchivements={getAchivements}
        loading={loading}
      />

      <EditAchievement
        isOpen={state.openEditAchievementModal}
        toggle={() => setState({ openEditAchievementModal: false, achievementId: null })}
        getAchivements={getAchivements}
        achievements={achievements}
        achievementId={state.achievementId}
        loading={loading}
      />

      <UserDetailsModal
        isOpen={state.showUserDetailsModal}
        toggle={() => setState({ reqUserId: '', showUserDetailsModal: false })}
        reqUserId={state.reqUserId}
      />
    </div >
  )
}

export default Achievements